module.exports = __webpack_public_path__ + "img/image-private-seal.c9046a38.png";